import React, { useEffect, useRef } from "react";

import "./Slider.css";

const Slider = () => {
  const logosRef = useRef(null);

  useEffect(() => {
    const logos = logosRef.current;
    const copy = logos.cloneNode(true);
    logos.parentNode.appendChild(copy);
  }, []);

  const services = [
    "Product Launch Updates",
    "Event Reminder Emails",
    "Seasonal Sale Alerts",
    "Subscription Reminders",
    "Behavior Insights",
    "Blog Post Highlights",
    "Discount Offers",
    "Subscription Reminders",
    "Product Recommendations",
    "Holiday Campaigns",
    "Feedback & Survey Requests",
  ];

  return (
    <>
      <div className="lp-container">
        <div className="tools">
          <div className="logos">
            <div className="logos-slide" ref={logosRef}>
              {services.map((service, index) => (
                <span key={index} className="service-slider">
                  {service}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Slider;
